import { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const useAnimation = (postData, ref) => {
  useEffect(() => {
    if (
      ref.current &&
      Array.from(document.querySelectorAll('.bubbles')).length > 0
    ) {
      const referenceBubblesPattern = Array.from(
        document.querySelectorAll('.bubbles-pattern circle')
      )
      const bubblesPatternDefaultViewbox = {
        w: 53,
        h: 166,
      }
      const stepLength = 60

      // These variables should be inherited from CSS
      // Once you change the layout, update the following:
      const yearCollapsedFullHeight = 450
      const yearNumberHeight = 32

      const pxToSvgRatio =
        document.querySelector('.bubbles').clientWidth /
        bubblesPatternDefaultViewbox.w

      let isMobile = window.innerWidth < 600
      let allBubblesToBrust = []

      const yearContainers = Array.from(
        document.querySelectorAll('.year-container')
      )
      let roadmapInfo = []
      yearContainers.forEach((yearContainer, yearContainerIdx) => {
        let yearInfo = {
          bubbleSVG: yearContainer.querySelector('svg.bubbles'),
          expandBtns: Array.from(
            yearContainer.querySelectorAll('.open-button')
          ),
          yearBoxes: Array.from(yearContainer.querySelectorAll('.year-box')),
          previews: Array.from(yearContainer.querySelectorAll('.preview')),
          fullTextBlocks: Array.from(
            yearContainer.querySelectorAll('.full-text')
          ),
          scrollTimeline: null,
          previewHeights: [],
          fullHeights: [],
          isLastFeetAnimation: false,
          // isFadedColor: false,
        }
        if (yearContainers[yearContainerIdx + 1]) {
          if (
            yearContainers[yearContainerIdx + 1].classList.contains('grey') &&
            !yearContainer.classList.contains('grey')
          ) {
            // yearInfo.isFadedColor = true
            yearContainer.classList.add('fade-colored')
            if (roadmapInfo[yearContainerIdx - 1]) {
              roadmapInfo[yearContainerIdx - 1].isLastFeetAnimation = true
            }
          }
        }
        yearInfo.fullHeights[0] = yearInfo.fullTextBlocks[0].clientHeight
        yearInfo.previewHeights[0] = yearInfo.previews[0].clientHeight
        gsap.set(yearInfo.fullTextBlocks[0], {
          height: 0,
        })
        if (yearInfo.fullTextBlocks.length === 2) {
          yearInfo.fullHeights[1] = yearInfo.fullTextBlocks[1].clientHeight
          yearInfo.previewHeights[1] = yearInfo.previews[1].clientHeight
          gsap.set(yearInfo.fullTextBlocks[1], {
            height: 0,
          })
        }
        roadmapInfo.push(yearInfo)
      })

      gsap.set('.road-container', {
        opacity: 1,
      })

      setupBoxesExpand()
      setupLayout()
      roadmapInfo.forEach((year, yearIdx) => {
        setupScrollAnimation(yearIdx)
      })
      setupBurstAnimation()

      window.addEventListener('resize', () => {
        isMobile = window.innerWidth < 600

        if (!isMobile) {
          roadmapInfo.forEach(year => {
            gsap.set(year.fullHeights, {
              height: 0,
            })
            // if (isMobile) {
            //   gsap.to(year.bubbleSVG, {
            //     paddingTop: 0,
            //   })
            //   gsap.to(yearContainers, {
            //     height: 'auto',
            //   })
            // }
          })
          setupLayout()
          roadmapInfo.forEach((year, yearIdx) => {
            setupScrollAnimation(yearIdx)
          })
        }
      })

      // eslint-disable-next-line no-inner-declarations
      function setupBoxesExpand() {
        roadmapInfo.forEach((year, yearIdx) => {
          year.expandBtns.forEach((btn, btnIdx) => {
            btn.onclick = function () {
              if (!year.fullTextBlocks[btnIdx].classList.contains('expanded')) {
                // Close all boxes
                roadmapInfo.forEach((_year, _yearIdx) => {
                  if (_yearIdx !== yearIdx) {
                    _year.expandBtns.forEach((_btn, _btnIdx) => {
                      closeBox(_btn, _year, _btnIdx, _yearIdx)
                    })
                  }
                })
                // Expand the box
                btn.classList.add('open')
                year.yearBoxes[btnIdx].classList.add('open')
                year.fullTextBlocks[btnIdx].classList.add('expanded')
                gsap.to(year.fullTextBlocks[btnIdx], {
                  duration: 0.6,
                  height: year.fullHeights[btnIdx],
                  ease: 'power1.inOut',
                })
                addExtraBubbles(yearIdx, btnIdx)
                if (roadmapInfo[yearIdx].isLastFeetAnimation) {
                  const feet = Array.from(
                    roadmapInfo[yearIdx].bubbleSVG.querySelectorAll('.foot')
                  )
                  const numberOfExtraSteps =
                    Math.floor(
                      (year.fullHeights[btnIdx] - year.previewHeights[btnIdx]) /
                        stepLength
                    ) - 2
                  const tl = gsap.timeline({}).timeScale(2)
                  for (let i = 0; i < numberOfExtraSteps; i++) {
                    tl.to(
                      feet[1],
                      {
                        duration: 0.03,
                        y: '+=' + stepLength,
                      },
                      i / numberOfExtraSteps + 0.6
                    ).to(
                      feet[0],
                      {
                        duration: 0.03,
                        y: '+=' + stepLength,
                      },
                      (i + 0.5) / numberOfExtraSteps + 0.6
                    )
                  }
                }
              } else {
                // Close clicked Box
                closeBox(btn, year, btnIdx, yearIdx)
              }
            }
          })
        })
      }

      // eslint-disable-next-line no-inner-declarations
      function closeBox(btn, year, btnIdx, yearIdx) {
        btn.classList.remove('open')
        year.yearBoxes[btnIdx].classList.remove('open')
        year.fullTextBlocks[btnIdx].classList.remove('expanded')
        if (roadmapInfo[yearIdx].isLastFeetAnimation) {
          if (roadmapInfo[yearIdx].isLastFeetAnimation) {
            const feet = Array.from(
              roadmapInfo[yearIdx].bubbleSVG.querySelectorAll('.foot')
            )
            const numberOfExtraSteps =
              Math.floor(
                (year.fullHeights[btnIdx] - year.previewHeights[btnIdx]) /
                  stepLength
              ) - 2
            const tl = gsap.timeline({}).timeScale(2)
            for (let i = 0; i < numberOfExtraSteps; i++) {
              tl.to(
                feet[1],
                {
                  duration: 0.03,
                  y: '-=' + stepLength,
                },
                (i + 0.5) / numberOfExtraSteps
              ).to(
                feet[0],
                {
                  duration: 0.03,
                  y: '-=' + stepLength,
                },
                i / numberOfExtraSteps
              )
            }
          }
        }
        // Collapse the box
        gsap.to(year.fullTextBlocks[btnIdx], {
          duration: 0.6,
          height: 0,
          ease: 'power1.inOut',
        })
        gsap.delayedCall(0.3, () => {
          removeExtraBubbles(yearIdx)
        })
      }

      // eslint-disable-next-line no-inner-declarations
      function setupLayout() {
        roadmapInfo.forEach((year, yearIdx) => {
          let svgHeight =
            yearContainers[yearIdx].clientHeight - yearNumberHeight
          const newHeight = svgHeight / pxToSvgRatio
          year.bubbleSVG.setAttribute(
            'viewBox',
            '-2 0 ' + bubblesPatternDefaultViewbox.w + ' ' + newHeight
          )

          let pattern = [...referenceBubblesPattern]
          let newBubble
          const bubbleGroup = year.bubbleSVG.querySelector('.bubbles-container')
          bubbleGroup.innerHTML = ''
          if (newHeight < bubblesPatternDefaultViewbox.h) {
            // pattern doesn't take a full height of the SVG
            pattern.forEach(b => {
              if (+b.getAttribute('cy') < newHeight - 7) {
                newBubble = b.cloneNode(true)
                bubbleGroup.appendChild(newBubble)
                allBubblesToBrust.push(newBubble)
              }
            })
          } else {
            // pattern takes more than a full height of the SVG
            const fullPatternsNumber = Math.floor(
              newHeight / bubblesPatternDefaultViewbox.h
            )
            for (let i = 0; i < fullPatternsNumber; i++) {
              pattern.forEach(b => {
                newBubble = b.cloneNode(true)
                bubbleGroup.appendChild(newBubble)
                allBubblesToBrust.push(newBubble)
                gsap.set(newBubble, {
                  attr: {
                    cy: '+=' + bubblesPatternDefaultViewbox.h * i,
                  },
                })
              })
            }
            // add the last cropped group
            const extraHeight =
              newHeight - bubblesPatternDefaultViewbox.h * fullPatternsNumber
            pattern.forEach(b => {
              if (+b.getAttribute('cy') < extraHeight) {
                newBubble = b.cloneNode(true)
                bubbleGroup.appendChild(newBubble)
                allBubblesToBrust.push(newBubble)
                gsap.set(newBubble, {
                  attr: {
                    cy:
                      '+=' +
                      bubblesPatternDefaultViewbox.h * fullPatternsNumber,
                  },
                })
              }
            })
          }
        })
      }

      // eslint-disable-next-line no-inner-declarations
      function addExtraBubbles(yearIdx, boxIdx) {
        const oldSvgHeight =
          roadmapInfo[yearIdx].bubbleSVG.viewBox.baseVal.height
        const newSvgHeight = Math.max(
          (roadmapInfo[yearIdx].previewHeights[boxIdx] +
            roadmapInfo[yearIdx].fullHeights[boxIdx] -
            30) /
            pxToSvgRatio,
          oldSvgHeight
        )

        roadmapInfo[yearIdx].bubbleSVG.setAttribute(
          'viewBox',
          '-2 0 ' + bubblesPatternDefaultViewbox.w + ' ' + newSvgHeight
        )

        const extraHeight = newSvgHeight - oldSvgHeight
        let pattern = [...referenceBubblesPattern]
        let newBubble
        const bubbleGroup = roadmapInfo[yearIdx].bubbleSVG.querySelector(
          '.bubbles-container'
        )
        let bubblesToShow = []
        // pattern takes more than a full height of the SVG
        const fullPatternsNumber = Math.floor(
          extraHeight / bubblesPatternDefaultViewbox.h
        )
        for (let i = 0; i < fullPatternsNumber; i++) {
          pattern.forEach(b => {
            newBubble = b.cloneNode(true)
            bubbleGroup.appendChild(newBubble)
            allBubblesToBrust.push(newBubble)
            gsap.set(newBubble, {
              attr: {
                cy: '+=' + (oldSvgHeight + bubblesPatternDefaultViewbox.h * i),
              },
            })
            bubblesToShow.push(newBubble)
          })
        }
        // add the last cropped group
        const extraExtraHeight =
          extraHeight - bubblesPatternDefaultViewbox.h * fullPatternsNumber
        pattern.forEach(b => {
          if (+b.getAttribute('cy') < extraExtraHeight) {
            newBubble = b.cloneNode(true)
            bubbleGroup.appendChild(newBubble)
            allBubblesToBrust.push(newBubble)
            gsap.set(newBubble, {
              attr: {
                cy:
                  '+=' +
                  (oldSvgHeight +
                    bubblesPatternDefaultViewbox.h * fullPatternsNumber),
              },
            })
            bubblesToShow.push(newBubble)
          }
        })
      }

      // eslint-disable-next-line no-inner-declarations
      function removeExtraBubbles(yearIdx) {
        const oldSvgHeight =
          roadmapInfo[yearIdx].bubbleSVG.viewBox.baseVal.height
        const newSvgHeight =
          (yearCollapsedFullHeight - yearNumberHeight) / pxToSvgRatio
        if (oldSvgHeight > newSvgHeight) {
          const bubblesGroup = roadmapInfo[yearIdx].bubbleSVG.querySelector(
            '.bubbles-container'
          )
          const bubblesReversed = Array.from(
            bubblesGroup.querySelectorAll('.bubbles-container circle')
          ).reverse()
          bubblesReversed.forEach(b => {
            if (+b.getAttribute('cy') > newSvgHeight) {
              const indexToDelete = allBubblesToBrust.indexOf(b)
              if (indexToDelete > -1) {
                allBubblesToBrust.splice(indexToDelete, 1)
              }
              bubblesGroup.removeChild(b)
            }
          })
          roadmapInfo[yearIdx].bubbleSVG.setAttribute(
            'viewBox',
            '-2 0 ' + bubblesPatternDefaultViewbox.w + ' ' + newSvgHeight
          )
        }
      }

      // eslint-disable-next-line no-inner-declarations
      function setupScrollAnimation(yearIdx) {
        const bubbles = Array.from(
          roadmapInfo[yearIdx].bubbleSVG.querySelectorAll('circle')
        )
        const feet = Array.from(
          roadmapInfo[yearIdx].bubbleSVG.querySelectorAll('.foot')
        )
        const svgHeight = roadmapInfo[yearIdx].bubbleSVG.viewBox.baseVal.height
        let numberOfSteps = Math.floor(svgHeight / stepLength) + 1
        if (roadmapInfo[yearIdx].isLastFeetAnimation) {
          numberOfSteps -= 1
        }

        // kill old instance
        gsap.killTweensOf(bubbles)
        if (roadmapInfo[yearIdx].scrollTimeline) {
          if (roadmapInfo[yearIdx].scrollTrigger) {
            roadmapInfo[yearIdx].scrollTrigger.kill(true)
          }
          roadmapInfo[yearIdx].scrollTimeline.kill(true)
        }

        roadmapInfo[yearIdx].scrollTimeline = gsap
          .timeline({ paused: true })
          .duration(1)
        roadmapInfo[yearIdx].scrollTrigger = ScrollTrigger.create({
          trigger: roadmapInfo[yearIdx].bubbleSVG,
          start: '0% 50%',
          end: '100% 50%',
          onUpdate: ({ progress }) =>
            roadmapInfo[yearIdx].scrollTimeline.progress() < progress
              ? roadmapInfo[yearIdx].scrollTimeline.progress(progress)
              : null,
        })

        bubbles.forEach((b, bIdx) => {
          const timeWeight = bIdx / bubbles.length - 0.5
          let startTime = bIdx / bubbles.length
          startTime += timeWeight * 0.1
          startTime += 0.2 * (Math.random() - 0.5)
          if (startTime < 0) {
            startTime = Math.random() * -startTime
          } else if (startTime > 0.99) {
            startTime = 0.99 - Math.random() * 2 * (startTime - 0.99)
          }

          roadmapInfo[yearIdx].scrollTimeline.fromTo(
            b,
            {
              attr: { r: 0 },
            },
            {
              duration: 0.1,
              attr: { r: b.getAttribute('data-size') },
              ease: 'back(2).out',
            },
            startTime
          )
        })

        for (let i = 0; i < numberOfSteps; i++) {
          roadmapInfo[yearIdx].scrollTimeline
            .to(
              feet[1],
              {
                duration: 0.03,
                y: '+=' + stepLength,
              },
              i / numberOfSteps
            )
            .to(
              feet[0],
              {
                duration: 0.03,
                y: '+=' + stepLength,
              },
              (i + 0.5) / numberOfSteps
            )

          if (
            !roadmapInfo[yearIdx].isLastFeetAnimation &&
            i === numberOfSteps - 1
          ) {
            roadmapInfo[yearIdx].scrollTimeline.set(
              feet,
              {
                opacity: 0,
              },
              (i + 0.5) / numberOfSteps
            )
          }
        }

        if (!yearIdx) {
          roadmapInfo[yearIdx].scrollTimeline
            .to(
              '.start-feet .foot-top',
              {
                duration: 0.03,
                opacity: 0,
              },
              0
            )
            .to(
              '.start-feet .foot-bottom',
              {
                duration: 0.03,
                opacity: 0,
              },
              0.5 / numberOfSteps
            )
        }
      }

      // eslint-disable-next-line no-inner-declarations
      function setupBurstAnimation() {
        gsap.ticker.remove(burstRandomBubble)
        gsap.ticker.add(burstRandomBubble)

        const frequency = 0.98

        function burstRandomBubble() {
          if (Math.random() > frequency) {
            let randomBubble = null
            let bubbleToCheck = null
            let bubbleRad
            let cnt = 30
            do {
              cnt--
              bubbleToCheck =
                allBubblesToBrust[
                  Math.floor(Math.random() * allBubblesToBrust.length)
                ]

              if (
                isInViewport(bubbleToCheck) &&
                +bubbleToCheck.getAttribute('r') > 0 &&
                +bubbleToCheck.getAttribute('data-is-animated') === 0
              ) {
                randomBubble = bubbleToCheck
                bubbleRad = +randomBubble.getAttribute('data-size')
                gsap
                  .timeline({
                    onStart: () =>
                      bubbleToCheck.setAttribute('data-is-animated', '1'),
                    onComplete: () =>
                      bubbleToCheck.setAttribute('data-is-animated', '0'),
                  })
                  .fromTo(
                    randomBubble,
                    {
                      attr: { r: bubbleRad },
                    },
                    {
                      duration: 0.12,
                      attr: { r: Math.max(bubbleRad * 1.15, 6) },
                    },
                    0.6
                  )
                  .set(randomBubble, {
                    attr: { r: 0 },
                  })
                  .to(
                    randomBubble,
                    {
                      duration: 0.2 * bubbleRad,
                      attr: { r: bubbleRad },
                      ease: 'back(1.2).out',
                    },
                    1.3 + Math.random()
                  )
              }
            } while (randomBubble === null && cnt)
          }
        }

        function isInViewport(element) {
          const rect = element.getBoundingClientRect()

          return (
            rect.top >= 0 &&
            rect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight)
          )
        }
      }
    }
  }, [postData, ref])
}

export default useAnimation
